import { Component } from 'react';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage } from 'react-intl';

// STYLES
import {
  Container,
  Relative,
  Modal,
  Header,
  Title,
  Close,
  Content,
  Footer,
  CancelButton,
  DeleteButton,
} from 'styles/modals';
import { Center } from 'styles/common';

// CONSTANTS
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

/**
 * @deprecated Use `RemoveConfirmation` instead.
 */
class DeleteConfirmation extends Component {
  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.loading) {
      return;
    }

    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  render() {
    return (
      <Container data-testid="delete-confirmation">
        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal loading={this.props.loading}>
            <Header>
              {/* @ts-expect-error TS(2339): Property 'title' does not exist on type 'Readonly<... Remove this comment to see the full error message */}
              <Title>{this.props.title}</Title>
              <Close
                onClick={() => {
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                }}
                className="icon-close-light"
              />
            </Header>

            <Content>
              {/* @ts-expect-error TS(2339): Property 'message' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <Center>{this.props.message}</Center>
            </Content>

            <Footer>
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <CancelButton onClick={this.handleCloseModal} disabled={this.props.loading} />
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              {!this.props.loading && (
                // @ts-expect-error TS(2339): Property 'onDelete' does not exist on type 'Readon... Remove this comment to see the full error message
                <DeleteButton onClick={this.props.onDelete}>
                  <FormattedMessage id="components.Modals.DeleteConfirmation.delete" />
                </DeleteButton>
              )}
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

export default DeleteConfirmation;
